module.exports = __webpack_public_path__ + "media/6.a1ca2740.mp3";